// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Mrsk","consentsList":"PatientConsents_consentsList__1Az4J","consentsListEmpty":"PatientConsents_consentsListEmpty__3PHFu"};